

module.exports = __webpack_require__.stylable.create(
    "Spinner3911318931",
    {"classes":{"root":"Spinner3911318931__root"},"vars":{},"stVars":{},"keyframes":{"spin":"Spinner3911318931__spin"}},
    "",
    2,
    "Spinner3911318931",
    null
);
